import { createFileRoute } from '@tanstack/react-router'
import { JoinWaitlist } from '@/components/auth/join-waitlist/join-waitlist'

export const Route = createFileRoute('/_auth/join-waitlist')({
  component: JoinWaitlistPage,
})

function JoinWaitlistPage() {
  return <JoinWaitlist />
}
